<!-- data-cs-name-owner keeps the capture-cover directive from naming this button after the host's text, which is the hidden tooltip body, not what the button does -->
<button #button cs-capture-cover data-cs-name-owner></button>
<ng-content select="[tooltip-trigger]"></ng-content>
@if (!hasCustomTrigger) {
  <cs-icon [name]="iconType"></cs-icon>
}
<span #tooltip class="tooltip-text">
  <cs-icon [ngClass]="'tooltip-caret'" [name]="tooltipPosition === 'right' ? 'caret-left' :
                   tooltipPosition === 'left' ? 'caret-right' :
                   tooltipPosition === 'top' ? 'caret-down' : 'caret-up'">
  </cs-icon>
  @if (text) {
    {{ text }}
  } @else {
    <ng-content></ng-content>
  }
</span>